import React, { useRef, useState } from 'react'
import {
    useJsApiLoader,
    GoogleMap,
    Marker,
    Autocomplete,
    DirectionsRenderer,
  } from '@react-google-maps/api'
  import Card from '@mui/material/Card';
  import CardActions from '@mui/material/CardActions';
  import CardContent from '@mui/material/CardContent';
  import CardMedia from '@mui/material/CardMedia';
  import Typography from '@mui/material/Typography';
  import TextField from '@mui/material/TextField';
  import Input from '@mui/material/Input';
  import Button from '@mui/material/Button';


function Map({ lat,lng,branchAddress }) {
    const center = { lat, lng }

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
        libraries: ['places'],
      })
    
      const [map, setMap] = useState(/** @type google.maps.Map */ (null))
      const [directionsResponse, setDirectionsResponse] = useState(null)
      const [distance, setDistance] = useState('')
      const [duration, setDuration] = useState('')
    
      /** @type React.MutableRefObject<HTMLInputElement> */
      const originRef = useRef()
      /** @type React.MutableRefObject<HTMLInputElement> */
      const destiantionRef = useRef()
    //   if (originRef.current.value === '' || destiantionRef.current.value === '') {
    //     return
    //   }
      async function calculateRoute() {
        if (originRef.current.value === '') {
          return
        }
        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService()
        const results = await directionsService.route({
          origin: originRef.current.value,
        //   destination: destiantionRef.current.value,
        destination: branchAddress,
          // eslint-disable-next-line no-undef
          travelMode: google.maps.TravelMode.DRIVING,
        })
        setDirectionsResponse(results)
        setDistance(results.routes[0].legs[0].distance.text)
        setDuration(results.routes[0].legs[0].duration.text)
      }
    
      function clearRoute() {
        setDirectionsResponse(null)
        setDistance('')
        setDuration('')
        originRef.current.value = ''
        // destiantionRef.current.value = ''
      }

  return (
      <div>
          <div>
              <div style={{display:'flex',flexWrap:'wrap'}}>
              <Autocomplete>
             <input type='text' placeholder='Origin' style={{border:'1px solid #88888888',height:35,borderRadius:5,marginLeft:5,marginTop:5}} ref={originRef} />
            </Autocomplete>
            <Autocomplete>
            <input type='text' value={branchAddress} style={{border:'1px solid #88888888',height:35,borderRadius:5,marginLeft:5,marginTop:5}}  />

            </Autocomplete>
            <Button style={{marginLeft:5,marginTop:5}} onClick={calculateRoute} variant="contained">Calculate Route</Button>
            <Button style={{marginLeft:5,marginTop:5}} onClick={clearRoute} variant="outlined">clear</Button>
              </div> 
              
              <div style={{marginTop:8,marginBottom:2}}>
              <TextField
          id="outlined-read-only-input"
          label="Distance"
          value={distance}
          InputProps={{
            readOnly: true,
            style:{
                marginLeft:"5px"
            }
          }}

        /> 
                      <TextField
          id="outlined-read-only-input"
          label="Duration"
          value={duration}
          InputProps={{
            readOnly: true,
            style:{
                marginLeft:"5px"
            }
          }}

        /> 
              </div>
          </div>
    <div style={{ height: '100vh', width: '100%' }}>
               <GoogleMap
          center={center}
          zoom={15}
          mapContainerStyle={{ width: '100%', height: '100%' }}
          options={{
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }}
          onLoad={map => setMap(map)}
        >
          <Marker position={center} />
          {directionsResponse && (
            <DirectionsRenderer directions={directionsResponse} />
          )}
        </GoogleMap> 
   </div>
      </div>
  )
}

export default Map